import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import ListingDetail from "@/pages/ListingDetail";
import CreateListing from "@/pages/CreateListing";
import Chats from "@/pages/Chats";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Profile from "@/pages/Profile";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Safety from "@/pages/Safety";
import HowItWorks from "@/pages/HowItWorks";
import Admin from "@/pages/Admin";
import Consent from "@/pages/Consent";
import Settings from "@/pages/Settings";

function AppShell() {
  const location = useLocation();
  // CRITICAL: Handle OAuth fragment before any other routing
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/browse" element={<Browse />} />
        <Route path="/listing/:id" element={<ListingDetail />} />
        <Route path="/sell" element={<CreateListing />} />
        <Route path="/sell/:id" element={<CreateListing />} />
        <Route path="/chats" element={<Chats />} />
        <Route path="/chats/:chatId" element={<Chats />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/users/:userId" element={<Profile />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/safety" element={<Safety />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/consent" element={<Consent />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppShell />
          <Toaster position="top-center" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
